import React, { Component } from 'react'
import DashboardHeader from '../profile/common/dashboardHeader'
import DashboardLeftBar from '../profile/common/dashboardLeftBar'
import Activity from './postAppointment/activity'
import DoctorSelection from './postAppointment/doctorSelection'
import { Helmet } from 'react-helmet'
import { WatiScript } from '../../../include/js/wati'
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from '../../../firebase'

class PostAppointment extends Component {
  state = {
    doctor_id: '',
    appointment_id: '',
    dropDown: false,
    tab: 'messages',
    scroll: true,
    showUnreadDot: false,
  }
  myRef = React.createRef()
  setDropDown = dropDown => this.setState({ dropDown })
  // updateStep = (e, step) => {
  //   if (e) e.preventDefault();
  //   this.setState({ step });
  // };
  setDoctorId = doctor_id => this.setState({ doctor_id })
  setAapointment_id = appointment_id => this.setState({ appointment_id })
  setTabe = tab => {
    this.setState({ tab })
  }

  dropDownToggle = () => {
    this.setState({ dropDown: !this.state.dropDown })
  }

  loadNotification = async () => {
    if (!this.props.patientId) return;
    // console.log("this.props.doctorProfile._id -----> ", typeof this.props.doctorProfile._id)
      const q = query(
      collection(db, "chatsSummary"),
      where("patientId", "==", this.props.patientId),
      where("readByPatient", "==", false)
    );
    const snapshot = await getDocs(q);
    // console.log("noti snapshot : ------> ", snapshot.docs)
    if (!snapshot.empty) {
      this.setState({showUnreadDot: true});
    } else {
      this.setState({showUnreadDot: false});
    }
  }

  componentDidMount = () => {
    document.body.classList.remove('p-0')
    this.loadNotification();
    this.pollInterval = setInterval(() => {
      this.loadNotification();
    }, 5000);
  }

  componentDidUpdate = () => {
    if (this.myRef.current && this.state.scroll) {
      let element = document.getElementById('activity-content')
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' })
        this.setState({ scroll: false })
      }
    }
  }

  componentWillUnmount() {
  clearInterval(this.pollInterval);
}
  render() {
    const { newDoctor = false, type = '' } = this.props
    return (
      <>
        {/* <Helmet>
          <script id='wati'>{WatiScript}</script>
        </Helmet> */}
        <div onClick={e => this.setState({ dropDown: false })}>
          {!newDoctor && (
            <>
              <DashboardLeftBar />
              <DashboardHeader />
            </>
          )}
          <div
            className={
              !newDoctor ? 'dashboard-main-container chatbot-container' : ''
            }>
            <div
              className={!newDoctor ? 'chatbot-pannel d-flex flex-wrap' : ''}>
              <DoctorSelection
                newDoctor={newDoctor}
                type={type}
                doctor_id={this.state.doctor_id}
                setDropDown={this.setDropDown}
                setAapointment_id={this.setAapointment_id}
                setDoctorId={this.setDoctorId}
                tab={this.state.tab}
                setTable={this.setTabe}
                dropDownToggle={this.dropDownToggle}
                dropDown={this.state.dropDown}
                appointment_id={this.state.appointment_id}
              />
              {this.state.doctor_id && !newDoctor && (
                <Activity
                  myRef={this.myRef}
                  appointment_id={this.state.appointment_id}
                  doctor_id={this.state.doctor_id}
                  dropDownToggle={this.dropDownToggle}
                  dropDown={this.state.dropDown}
                  showUnreadDot={this.state.showUnreadDot}
                />
              )}
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default PostAppointment
